import { ChevronRight, Cross } from '@components/icons'
import cn from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC } from 'react'

interface menuItem {
  linkTitle: string
  link: string
}

interface Props {
  title: string
  menuItems: menuItem[]
  onClose: () => void
}

const MobileAuxSideBar: FC<Props> = ({ title, menuItems, onClose }) => {
  const { asPath } = useRouter()
  // className={cn({ selected: asPath === i?.link })}
  if (menuItems.length === 0) return <></>

  return <>
    <div className="fixed-component-shadow bg-brand-light-grey">
      <div>
        <button
          onClick={onClose}
          className="flex justify-end w-full py-4 px-4"
        >
          <Cross />
        </button>
      </div>
      <div className="text-center align-center px-20 pb-8">
        <div className="text-body2 font-bold text-dark-grey uppercase">
          {title}
        </div>
      </div>
      <ul className="px-6">
        {menuItems.map((i, index) => {
          return (
            <li key={index}>
              <Link
                href={i?.link || '/'}
                passHref
                className={cn(
                  'flex justify-between items-center text-body1 font-light text-brand-dark-grey pb-6',
                  {
                    'body-1-bold text-brand-dark-grey': asPath === i?.link,
                  }
                )}>

                {i?.linkTitle}
                <ChevronRight width="20" height="20" />

              </Link>
            </li>
          );
        })}
      </ul>
      <div className="border-t border-grey block w-full lg:w-76"></div>
    </div>
  </>;
}

export default MobileAuxSideBar
